'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'meteor';
var width = 512;
var height = 512;
var aliases = [9732];
var unicode = 'f753';
var svgPathData = 'M304 16C287.4 25.6 219.8 64.7 101.3 133.4 38.6 169.7 0 236.6 0 309 0 421.1 90.9 512 203 512 275.4 512 342.3 473.4 378.6 410.7 447.3 292.2 486.4 224.6 496 208l-7.5 .6-50.5 3.9-1.9 .1c8.5-23.8 26.9-75.2 55.1-154.2L512 0c-31.2 11.2-85.6 30.6-163.1 58.3l-49.5 17.7 .1-1.9 3.9-50.5 .6-7.5zM125.3 174.9l123.8-71.7-3.3 42.8c38.5-13.8 100.8-36 186.9-66.7-30.7 86-53 148.3-66.7 186.9l42.8-3.3-71.7 123.8c-27.7 47.9-78.8 77.3-134.1 77.3-85.6 0-155-69.4-155-155 0-55.3 29.5-106.4 77.3-134.1zM200 424a112 112 0 1 0 0-224 112 112 0 1 0 0 224zM176 264a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm24 96a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faMeteor = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;